import { PageRef } from 'providers/page-ref';

export type CoachCheckoutPageParams = {};

/** Become-a-coach checkout on the web (Paddle per-seat rail, Phase 4, #3919).
 *  Reached from the "Become a Coach" entry on the user-profile menu; hosts the
 *  embedded inline Paddle coach-seat checkout. See the `CoachCheckoutPage` class
 *  doc for the full flow and `design-docs/paddle-integration.md`. */
export const ICoachCheckoutPage: PageRef<CoachCheckoutPageParams, void> = {
  pageName: 'CoachCheckoutPage',
} as PageRef<CoachCheckoutPageParams, void>;
